var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bus",
    transform: "translate(-165 -485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bus-2",
    "data-name": "bus",
    transform: "translate(165 485)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "base",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M18.681,90.414H11.559c0-.8-1.163-1.09-1.89-1.09H2.038a.573.573,0,0,0-.581.581v.509H1.093A1.056,1.056,0,0,0,0,91.432v7.995a.651.651,0,0,0,.654.654H3.128a2.041,2.041,0,0,0,2.035,1.672,2.182,2.182,0,0,0,2.108-1.672h7.122a2.041,2.041,0,0,0,2.035,1.672,2.182,2.182,0,0,0,2.108-1.672h1.672c1.526,0,.218-9.666-1.526-9.666Zm-.073.727c.654.436,1.308,3.416,1.454,5.887,0,.145,0,.291-.218.291H18.609a.617.617,0,0,1-.581-.509c-.218-1.308-2.108-2.253-2.834-2.253V91.141h3.416Zm-4.143,3.416H10.178V91.141h4.288Zm-5.015,0H5.236V91.141H9.451Zm-4.942,0H.73V91.432a.333.333,0,0,1,.363-.291H4.509Zm.654,3.925A1.163,1.163,0,1,1,4,99.644,1.148,1.148,0,0,1,5.163,98.481Zm11.265,0a1.163,1.163,0,1,0,1.163,1.163A1.148,1.148,0,0,0,16.428,98.481Z",
    transform: "translate(1.997 -83.324)",
    fill: "#19bc9c",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.4301b5aad5f9fdf52839ab52888ca108.svg";
export { ForwardRef as ReactComponent };